
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector('#recently-viewed-products');
  const wrapper = document.querySelector('#recently-viewed-wrapper');
  let swiperInstance = null;

  if (!container || !wrapper) return;

  function getSearchQueryString() {
    let items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
    return items.map(id => `id:${id}`).join(' OR ');
  }

  function fetchProducts() {
    const queryString = getSearchQueryString();
    if (!queryString) return;

    const locale = document.documentElement.getAttribute('lang');
    const isArabic = locale === 'ar';
    const searchUrl = isArabic
    ? `/${locale}/search?view=recently-viewed-products&type=product&q=${encodeURIComponent(queryString)}`
    : `/search?view=recently-viewed-products&type=product&q=${encodeURIComponent(queryString)}`;
    fetch(searchUrl, {
      credentials: 'same-origin',
      method: 'GET'
    })
    .then(res => res.text())
    .then(html => {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      const section = tempDiv.querySelector('.recentView-main');
      if (section) {
        container.innerHTML = section.innerHTML;
        wrapper.style.display = 'block';
        attachRemoveHandlers(container, wrapper);
        waitForRecentViewAndInitSwiper();
      }
    })
    .catch(console.error);
  }

  fetchProducts();

  function waitForRecentViewAndInitSwiper() {
    const interval = setInterval(() => {
      const recentView = container.querySelector('.recentview');
      const wrapperEl = recentView?.querySelector('.recentview-item-wrapper');
      const items = recentView?.querySelectorAll('.recentview-items') || [];

      if (recentView && wrapperEl && items.length > 0) {
        clearInterval(interval);
        initSwiperGlobally();
      }
    }, 100); // check every 100ms
  }

  function initSwiperGlobally() {
    const recentView = container.querySelector('.recentview');
    const wrapperEl = recentView?.querySelector('.recentview-item-wrapper');
    const items = recentView?.querySelectorAll('.recentview-items');

    if (!recentView || !wrapperEl || !items) return;

    // Add Swiper classes
    recentView.classList.add('swiper');
    wrapperEl.classList.add('swiper-wrapper');
    wrapperEl.classList.remove('grid', 'grid--5-col-desktop');
    items.forEach(item => {
      item.classList.add('swiper-slide');
      item.classList.remove('grid__item');
    });

    if (!swiperInstance) {
      swiperInstance = new Swiper('.recentview', {
        slidesPerView: 2,
        spaceBetween: 20,
        pagination: {
          el: '.slider__pagination-recentview',
          clickable: true,
        },
        breakpoints: {
          480: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
          1024: {
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
            slidesPerGroup: 2
          }
        }
      });
    }
  }

  // Optional: Re-init Swiper on resize if needed
  window.addEventListener('resize', () => {
    if (swiperInstance) swiperInstance.update();
  });

  function attachRemoveHandlers(container, wrapper) {
    const removeButtons = container.querySelectorAll('.remove-recent-btn');
    removeButtons.forEach(button => {
      button.addEventListener('click', function () {
        const productElement = button.closest('[data-product-id]');
        const productId = productElement?.getAttribute('data-product-id');
        if (!productId) return;

        let items = JSON.parse(localStorage.getItem('recentlyViewedProducts') || '[]');
        items = items.filter(id => id.toString() !== productId.toString());
        localStorage.setItem('recentlyViewedProducts', JSON.stringify(items));

        console.log(items)
        productElement.remove();

        if (swiperInstance) swiperInstance.update();

        
        if (container.querySelectorAll('[data-product-id]').length === 0) {
          wrapper.style.display = 'none';
        }
      });
    });
  }
});
